import React from 'react';  

export default function ViewMoreButton(props) {
  const { condition, handleClick, state } = props;

  if (!condition) return <></>;

  return (
    <div className="my-2" style={{ marginRight: "5px" }}>
      <button className={`btn text-primary btn-sm`} onClick={handleClick}>
        <u>view {state ? "less" : "more"}</u>
      </button>
    </div>
  );
}
